import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { runMigrationOnLoad } from './services/persistence'

// Run localStorage → SQLite migration on app load
runMigrationOnLoad().then(status => {
  if (status.completed && status.recordsMigrated > 0) {
    console.log(`[Migration] Migrated ${status.recordsMigrated} records to SQLite`)
  }
}).catch(err => {
  console.warn('[Migration] Migration check failed:', err)
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
